import React from 'react'
import Layout from '../../components/layout/Layout'

const DownloadTemplates = () => {
  return <Layout>DownloadTemplates</Layout>
}

export default DownloadTemplates
